import { Document, Page, pdf, Text } from '@react-pdf/renderer';
import { fetchAllSKU } from 'api/sku';
import { washHub } from 'store';
import { Order } from 'types/order';
import { SKU } from 'types/sku';
import { errorToast } from 'utils/errorToast';
import { OrderDetailsPage } from './OrderDetailPDFTemplate';

const MultipleOrderDetailsTemplate = ({
  orders,
  skuData,
  options,
}: {
  orders: Order[];
  skuData: Record<string, SKU[]>;
  options?: {
    fileName?: string;
  };
}) => {
  // Validate orders array
  if (!orders?.length) {
    return (
      <Document>
        <Page>
          <Text>No orders available</Text>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      {orders.map((order, index) => {
        const site = order.site?._id ?? '';
        const skuDataForSite = skuData[site] || [];

        // Validate order data
        if (!order || !order.site) {
          return null;
        }

        return (
          <OrderDetailsPage key={index} data={order} skuData={skuDataForSite} />
        );
      })}
    </Document>
  );
};

export const downloadOrders = async (
  orders: Order[],
  options?: {
    fileName?: string;
  },
) => {
  if (!orders?.length) {
    errorToast('No orders found');
    return;
  }

  //   try {
  // Validate orders data
  const validOrders = orders.filter((order) => order && order.site);

  if (!validOrders.length) {
    throw new Error('No valid orders to generate PDF');
  }

  // Fetch SKU data for all sites in parallel
  const skuDataPromises = validOrders.map(async (order) => {
    const site = order.site?._id ?? '';
    if (!site) {
      console.warn('Order missing site ID:', order);
      return { site: '', data: [] };
    }
    const response = await fetchAllSKU('package', undefined, site, true, true);
    return { site, data: response || [] };
  });

  const skuDataResults = await Promise.all(skuDataPromises);
  const skuData = skuDataResults.reduce((acc, { site, data }) => {
    if (site) {
      acc[site] = data;
    }
    return acc;
  }, {} as Record<string, SKU[]>);

  const fileName = options?.fileName
    ? options.fileName.includes('.pdf')
      ? options.fileName
      : `${options.fileName}.pdf`
    : 'Deliveries.pdf';

  // Create PDF document
  const blob = await pdf(
    <MultipleOrderDetailsTemplate orders={validOrders} skuData={skuData} />,
  ).toBlob();

  // Download file
  const link = document.createElement('a');
  const blobUrl = window.URL.createObjectURL(blob);

  try {
    link.href = blobUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  } finally {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  }
  //   } catch (error) {
  //     console.error('Failed to download orders:', error);
  //     throw error;
  //   }
};

export default MultipleOrderDetailsTemplate;
